import {inject} from "aurelia-framework";
import {Client} from "../../../api/client";
import {DialogController} from 'aurelia-dialog';
import {FlashService} from "../../../flash/flash-service";
import moment from 'moment-timezone';
import * as _ from "lodash";
import {FormServiceFactory} from "../../../form/service/form-service-factory";
import {ConfigurationLoader} from "../../../form/loader/configuration-loader";

@inject(Client, DialogController, FlashService, ConfigurationLoader, FormServiceFactory)
export class RouteSearch {

    constructor(client, dialogController, flash, configurationLoader, formServiceFactory) {
        this.client = client;
        this.dialogController = dialogController;
        this.flash = flash;
        this.configurationLoader = configurationLoader;
        this.formServiceFactory = formServiceFactory;

        this.isRoundTrip = false;
        this.currentStep = null;

        this.submitHandler = this.submit.bind(this);
    }

    onSelectionChangedCallback() {
        const stepsAndSelectedItemsCount = {
            'search-trip': 1,
            'search-round-outbound-trip': 2,
        }

        return (selectedItems) => {
            const requiredCount = stepsAndSelectedItemsCount[this.currentStep] ?? false;

            if (!requiredCount) {
                this.flash.error(error || 'Ein unbekannter Fehler ist aufgetreten.');
                console.error('Step ' + this.currentStep + ' has no required count.');
                return;
            }

            const isSelectedCountMatch = this.selectedItems.length === requiredCount;

            const isEmptyCurrentSelection = 0 === (selectedItems ?? []).length;

            if (isSelectedCountMatch && isEmptyCurrentSelection) {
                this.selectedItems.pop();
                return;
            }

            selectedItems.forEach(selectedItem => {
                this.selectedItems.push(selectedItem);
            });
        }
    }

    async activate(context) {
        console.log('context', context);
        this.data = context.data;
        this.order = context.order;
        this.title = context.title;
        this.participants = context.participants;

        this.data = {
            participants: context.participants,
            order: this.order,
        };

        this.selectedItems = [];
    }

    _calculateParticipantCount(object) {
        let adultCount = 0;
        let childCount = 0;
        let infantCount = 0;

        let lastDepartureDate = null;

        if (object.itinerary.departureDate) {
            lastDepartureDate = object.itinerary.departureDate;
        }

        for (let participant of this.participants) {

            let birthdate = participant.customer && participant.customer.birthdate ? participant.customer.birthdate : null;

            if (birthdate) {
                let years = moment(lastDepartureDate).diff(moment(birthdate), 'years');

                if (years < 2) {
                    infantCount++;
                } else if (years < 12) {
                    childCount++;
                } else {
                    adultCount++;
                }
            } else {
                adultCount++;
            }
        }

        this.infantCount = infantCount;
        this.childCount = childCount;
        this.adultCount = adultCount;
    }

    setStep(step) {
        if ('search-round-outbound-trip' === step) {
            if (this.selectedItems.length !== 1) {
                this.flash.error('Bitte ein Ergebnis auswählen');

                return;
            }
        }

        this.currentStep = step;
    }

    async submit({object}) {
        this.loading = true;
        this.searchId = null;

        try {
            this.data = _.cloneDeep(object);

            this._calculateParticipantCount(object);

            object.childCount = this.childCount;
            object.infCount = this.infantCount;

            if (object.adultCount == null || object.adultCount == 0) {
                object.adultCount = this.adultCount;
            }

            let data = (await this.client.post('tourism-bus-routing/booking/fare-search', Object.assign(
                {},
                object))).data;

            this.loading = false;
            this.isRoundTrip = object.isRoundTrip;

            //Todo error display

            if (!data.searchId) {
                this.flash.error('Es konnte kein Suchergebnis gefunden werden');
            }

            this.searchId = data.searchId;
            this.roundTripSearchId = data.roundTripSearchId ?? null;

            this.setStep('search-trip');
        } catch (err) {
            this.loading = false;
            this.searchId = null;

            let error = null;

            if (err && err.data) {
                if (err.data.localizedMessage) {
                    error = err.data.localizedMessage;
                } else if (err.data.message) {
                    error = err.data.message;
                }
            }

            this.flash.error(error || 'Ein unbekannter Fehler ist aufgetreten.');
        }
    }

    back() {
        if ('search-round-outbound-trip' === this.currentStep) {
            if (2 === this.selectedItems.length) {
                this.selectedItems.pop();
            }

            this.setStep('search-trip');

            return;
        }

        this.roundTripSearchId = null;
        this.searchId = null;
        this.currentStep = null;
        this.selectedItems = [];
    }

    ok() {
        const minimumRequiredSelectionAmount =
            (true === this.isRoundTrip && 'search-round-outbound-trip' === this.currentStep) ? 2 : 1;

        if (this.selectedItems.length !== minimumRequiredSelectionAmount) {
            this.flash.error('Bitte ein Ergebnis auswählen');
            return;
        }

        const payload = [];

        const buildLabel = searchResult => {
            const itinerary = searchResult.routeItinerary;

            const itineraryDate = new Date(itinerary?.date);

            const formatDate = (data, formatStr) => moment(data).format(formatStr === 'dd.MM.yyyy' ? 'DD.MM.YYYY' : formatStr);

            const date = formatDate(itineraryDate, 'dd.MM.yyyy');

            return `${itinerary?.title} (${date}): ${searchResult?.title}`;
        };

        payload.push(
            {
                label: buildLabel(this.selectedItems[0]),
                id: this.selectedItems[0].id,
                modelId: this.selectedItems[0].modelId,
            },
        );

        if (true === this.isRoundTrip) {
            payload.push({
                label: buildLabel(this.selectedItems[1]),
                id: this.selectedItems[1].id,
                modelId: this.selectedItems[1].modelId,
            })
        }

        this.dialogController.ok(payload);
    }
}
